import { apiClient } from "./index.js";
import {sanitizePostData} from "@/utils/index.js";

async function addVacancy(vacancyFormData) {
  const { data } = await apiClient({
    method: 'post',
    url: '/api/Vacancies/AddVacancy',
    data: sanitizePostData(vacancyFormData),
    generalErrorsOnly: true,
  });
  return data;
}

async function updateVacancy(vacancyFormData) {
    const { data } = await apiClient({
        method: 'post',
        url: '/api/Vacancies/UpdateVacancy',
        data: sanitizePostData(vacancyFormData),
        generalErrorsOnly: true,
    });
    return data;
}

async function deleteVacancy(id) {
    const { data } = await apiClient({
        method: 'post',
        url: `/api/Vacancies/DeleteVacancy`,
        data: { id },
        generalErrorsOnly: true,
    });
    return data;
}

async function applyToVacancy(id, coverLetter) {
    const { data } = await apiClient({
        method: 'post',
        url: `/api/Vacancies/ApplyToVacancy`,
        data: { "vacancyId": id, coverLetter },
        generalErrorsOnly: true,
    });
    return data;
}


export { addVacancy, deleteVacancy, updateVacancy, applyToVacancy };